"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TrackingProvider = void 0;

var _react = _interopRequireWildcard(require("react"));

var _matomoTrackerReact = require("@datapunt/matomo-tracker-react");

var _trackingAppName = require("./trackingAppName");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal
 */

/**
 * This comonent will provide a shared matomo instance to send
 * tracking events with.
 *
 * @param {*} {siteId, children}
 * @return {*} 
 */
var TrackingProvider = function TrackingProvider(_ref) {
  var siteId = _ref.siteId,
      children = _ref.children,
      appName = _ref.appName;
  var matomoInstance = (0, _matomoTrackerReact.createInstance)({
    urlBase: 'https://go.traceup.com',
    siteId: siteId,
    trackerUrl: 'https://ed210.go.traceup.com/ed210.php',
    srcUrl: 'https://ed210.go.traceup.com/ed210.js',
    disabled: false,
    heartBeat: {
      active: true,
      seconds: 10
    },
    linkTracking: true,
    configurations: {
      disableCookies: true,
      setSecureCookie: true,
      setRequestMethod: 'POST'
    }
  });
  (0, _react.useEffect)(function () {
    if (appName && appName.length > 0) {
      (0, _trackingAppName.getSharedTrackingAppName)().appName = appName;
    }
  }, [appName]);
  return /*#__PURE__*/_react.default.createElement(_matomoTrackerReact.MatomoProvider, {
    value: matomoInstance
  }, children);
};

exports.TrackingProvider = TrackingProvider;